import { createLazyReactDirective } from '../../shell/ng';

export default createLazyReactDirective(
  async () => (await import('./UserSettings')).UserSettings,
  'userSettings',
);
